type Query = Record<string, string | string[] | undefined>;

/** Turning `next/navigation`'s params and search params into the pages router's `query`. */
export const routerQueryService = {
  /** Path params and search params together; a key repeated in the search becomes an array. */
  merge(
    params: Record<string, string | string[] | undefined> | null,
    search: Pick<URLSearchParams, "forEach"> | null,
  ): Query {
    const query: Query = {};
    search?.forEach((value, key) => {
      const current = query[key];
      query[key] =
        current === undefined
          ? value
          : Array.isArray(current)
            ? [...current, value]
            : [current, value];
    });
    // Path params win, as in the pages router.
    return { ...query, ...(params ?? {}) };
  },

  /**
   * `pathname` with `query` as its search, leaving out `omit` (the path's own params, which
   * the pages router took into the path from an object `push`). Empty values are dropped;
   * an array repeats its key.
   */
  href(
    pathname: string,
    query: Record<string, string | number | string[] | undefined>,
    omit: string[] = [],
  ): string {
    const search = new URLSearchParams();
    for (const [key, value] of Object.entries(query)) {
      if (omit.includes(key) || value === undefined || value === "") continue;
      for (const item of Array.isArray(value) ? value : [value])
        search.append(key, String(item));
    }
    const text = search.toString();
    return text ? `${pathname}?${text}` : pathname;
  },
};
